import { useAppSelector } from '@common/hooks'
import { useMemo } from 'react'

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  test: string,
}

export default function Image({
  src,
  alt,
}: IProps): JSX.Element {
  const validBasePath = useAppSelector(store => store.common.data.config?.IMAGE_DOMAIN)
  const validatedSrc = useMemo(() => {
    if(src && decodeURIComponent(src)) {
      const decodedSrc = decodeURIComponent(src)
      const regex = /\{image:([0-9a-f]{40}\.(png|jpg|jpeg|gif|webp))\}/
      const match = decodedSrc.match(regex)
      if(match && validBasePath) {
        const pngName = match[1]
        const newUrl = `${validBasePath}${validBasePath.endsWith('/') ? '' : '/'}application_images/${pngName}`
        return newUrl
      }
    } else {
      if(!src || (validBasePath && !src.startsWith(validBasePath))) {
        return undefined
      }
      return src
    }
  }, [src, validBasePath])

  return (
    <img src={validatedSrc} alt={alt}/>
  )
}
